import instanceQuery from '../../../graphql/queries/bank/BankPaymentReceiptTransactionQuery.graphql';
import fragment from '../../../graphql/fragments/nominal/PostedTransactionsFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const BankPaymentReceiptTransactions: EntityType = {
  type: 'PostedTransactionsResponse',
  formTitle: 'Posted Transactions',
  title: 'Posted Transactions',
  instance: instanceQuery,
  fragment,
  screenReference: 'BANK_PAYMENT_RECEIPT_POSTED_TRANSACTIONS',
};

export default BankPaymentReceiptTransactions;
